import { useAuthContext } from 'noddi-web';
import { isUserGroupMember } from '../utils/userGroupMembership';

/** Whether the signed-in session is a member of `userGroupId` (see `isUserGroupMember`). */
export function useIsUserGroupMember(userGroupId: number | null | undefined): boolean {
  const { userData } = useAuthContext();
  return isUserGroupMember(userGroupId, userData?.user.userGroups);
}
